import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FeedbackService } from 'src/app/services/feedback.service';
import * as fa from '@fortawesome/free-solid-svg-icons';
import * as fr from '@fortawesome/free-regular-svg-icons';
import { Shift } from 'src/app/classes/shift';
import { ShareComponent } from './share/share.component';
import { Share

 } from '@capacitor/share';
@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
})
export class FeedbackComponent  implements OnInit {
  shift!: Shift
  fa = fa
  fr = fr
  canShare = false

  form = new FormGroup({
    type: new FormControl(''),
    feedback: new FormControl(''),
    shift: new FormControl(),
    rating: new FormControl(),
    refund: new FormControl(),
    bonus: new FormControl()
  })

  constructor(
    private feedbackService: FeedbackService,
    public activeModal: NgbActiveModal,
    private modalService: NgbModal) { }

  ngOnInit() {
    Share.canShare().then(res => {
      this.canShare = res.value
    })

    this.form.controls.shift.setValue(this.shift.id)
  }

  save() {
    this.feedbackService.save(this.form.value).subscribe(_data => {
      this.activeModal.close()

      if(this.canShare && this.form.controls.rating.value >= 4) {
        const modal = this.modalService.open(ShareComponent, { centered: true })

        modal.componentInstance.feedback = this.form.value
      }
    })
  }
}
